export const LOW_STORAGE_WARNING_THRESHOLD_BYTES = 5 * 1024 ** 3

export const getAvailableStorageBytes = async (): Promise<number | null> => {
	if (typeof navigator === "undefined" || !navigator.storage?.estimate) {
		return null
	}
	try {
		const { quota, usage } = await navigator.storage.estimate()
		if (typeof quota !== "number" || typeof usage !== "number") {
			return null
		}
		return Math.max(0, quota - usage)
	} catch {
		return null
	}
}
